import axios from 'axios'

/**
 * 全局 axios 实例
 * - 统一 timeout / baseURL
 * - 请求头自动注入 Authorization / X-Device-Id / X-Trace-Id
 * - 响应统一处理 { code, msg, data } 协议
 * - 401 时清除本地凭据并触发重登
 */

var TIMEOUT = 10000
var TOKEN_KEY = 'gc_auth_token'
var DEVICE_KEY = 'gc_device_id'

// 后端所有资源都部署在 /mygames 子路径下（接口 + 上传的图片），前端所有请求统一带此前缀。
// 开发和生产的最终请求路径完全一致（都命中 /mygames/*），后端不需要感知环境差异。
var API_BASE = '/mygames'

function getDeviceId() {
  try {
    var id = localStorage.getItem(DEVICE_KEY)
    if (!id) {
      id = 'web_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10)
      localStorage.setItem(DEVICE_KEY, id)
    }
    return id
  } catch (e) {
    return 'web_unknown'
  }
}

function genTraceId() {
  return 't_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
}

export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY) || '' } catch (e) { return '' }
}

export function setAuthToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch (e) {}
}

// 401 处理回调，由 store 注册，避免循环依赖
var unauthorizedHandler = null
export function onUnauthorized(fn) { unauthorizedHandler = fn }

var http = axios.create({
  baseURL: API_BASE,
  timeout: TIMEOUT
})

http.interceptors.request.use(function(config) {
  config.headers = config.headers || {}
  var token = getAuthToken()
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = 'Bearer ' + token
  }
  config.headers['X-Device-Id'] = getDeviceId()
  config.headers['X-Trace-Id'] = genTraceId()
  return config
})

http.interceptors.response.use(function(res) {
  // 兼容后端 { code, msg, data } 协议
  var d = res.data
  if (d && typeof d === 'object' && 'code' in d) {
    if (d.code === 200 || d.code === 0) {
      return d.data !== undefined ? d.data : d
    }
    if (d.code === 401 || d.code === 403) {
      setAuthToken('')
      if (unauthorizedHandler) unauthorizedHandler()
      return Promise.reject(new Error(d.msg || 'Unauthorized'))
    }
    return Promise.reject(new Error(d.msg || ('code ' + d.code)))
  }
  return d
}, function(err) {
  if (err && err.response && (err.response.status === 401 || err.response.status === 403)) {
    setAuthToken('')
    if (unauthorizedHandler) unauthorizedHandler()
  }
  return Promise.reject(err)
})

export default http
